import { Route, Router, Routes } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Daftar from './pages/Daftar';
import Login from './pages/Login';
import Main from './pages/main/Main';
import Berkas from './pages/admin/Berkas';
import Progress from './pages/admin/Progress';
import LoginAdmin from './pages/admin/LoginAdmin';
import AdminChecker from './components/general/AdminChecker';
import Bayar from './pages/admin/Bayar';
import EditData from './pages/main/EditData';
import Config from './pages/admin/Config';

function App() {
  return (
    <Routes>
      {/* Parent route with Layout */}
      <Route path="/" element={<Layout />}>
        {/* Nested routes render inside Layout's Outlet */}
        <Route index element={<Home />} />
        <Route path="main" element={<Main />} />
        <Route path="editdata/:idSantri" element={<EditData />} />
        <Route path="login" element={<Login />} />
        <Route path="progress" element={<AdminChecker><Progress /></AdminChecker>} />
        <Route path="berkas" element={<AdminChecker><Berkas /></AdminChecker>} />
        <Route path="bayar" element={<AdminChecker><Bayar /></AdminChecker>} />
        <Route path="config" element={<AdminChecker><Config /></AdminChecker>} />
        <Route path="daftar/:tingkat?" element={<Daftar />} />
        {/* <Route path="contact" element={<Contact />} /> */}
      </Route>
      <Route path="/loginAdmin" element={<LoginAdmin></LoginAdmin>}></Route>

      {/* Optional standalone routes without the Layout */}
      <Route path="*" element={<h1>404 Not Found</h1>} />
    </Routes>
  );
}

export default App;
